const LOAD_DETAIL_BANK           = 'LOAD_DETAIL_BANK'
const LOAD_DETAIL_BANK_SUCCESS   = 'LOAD_DETAIL_BANK_SUCCESS'
const LOAD_DETAIL_BANK_FAILED    = 'LOAD_DETAIL_BANK_FAILED'
const UNMOUNT_DETAIL_BANK        = 'UNMOUNT_DETAIL_BANK'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const bankDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_BANK:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_BANK_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_BANK_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_BANK:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default bankDetailReducer;